import { useState, useEffect } from 'react';
import API from '../../../../services/API';
import { Space, Button, InputNumber, Checkbox ,Modal, message } from 'antd';
import { PAYMENT_PRODUCT_TYPE } from '../../../../constants/AppConstants';

export default function AutoPayAction({ autoPayStatusEnabled, refreshList, type, userId, originalAutoPayDay = null }) {

  const [loading, setLoading] = useState(false);
  const [productType, setProductType] = useState(type === PAYMENT_PRODUCT_TYPE.CREDIT_CARD ? "creditcard" : type === PAYMENT_PRODUCT_TYPE.SAVINGS_BUILDER ? "loan" : "all");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [autoPayDay, setAutoPayDay] = useState(originalAutoPayDay);
  const [autoPayStatus, setAutoPayStatus] = useState(autoPayStatusEnabled);

  /** Invoke AutoPay API */
  const invokeAutoPay = async (status, autoPayDay = null) => {
    /** Show confirmation dialog */
    const messagePopup = !status ? "Are you sure you want to disable AutoPay?" : "Are you sure you want to enable AutoPay?";
    if (!window.confirm(messagePopup)) { return; }
    setLoading(true);
    /** Invoke AutoPay API */
    try {
        await API.setAutoPayStatus({ userId, type: productType, isDisabled: !status, autoPayDay: autoPayDay });
        message.success(!status ? "AutoPay disabled successfully" : "AutoPay enabled successfully");
    } catch (error) {
        console.error(error);
        message.error(error?.response?.data?.error_message || error?.response?.data?.errorMessage);
    } finally {
      setLoading(false);
      refreshList();
    }
  }

  const showAutoPayDayModal = () => {
    if (productType === "all") {
      invokeAutoPay(!autoPayStatus);
    } else {
      setIsModalOpen(true);
    }
  }

  const handleAutoPayDaySubmit = () => {
    setIsModalOpen(false);
    invokeAutoPay(autoPayStatus, autoPayDay);
  }

  return (
    <>
      <Button className={'card-bottom-buttons'} type="primary" onClick={showAutoPayDayModal} loading={loading}>
        {
          productType !== "all" ? 'Change AutoPay Status' : (autoPayStatusEnabled ? 'Disable AutoPay' : 'Enable AutoPay')
        }
      </Button>
    {/* Modal for setting AutoPay day */}
    <Modal title={"Auto Pay Day Settings"} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
      <div style={{ marginBottom: 16 }}>
        <label>
          <input
            type="checkbox"
            checked={autoPayStatus}
            onChange={e => {
              setAutoPayStatus(e.target.checked === true);
            }}
            disabled={loading}
            style={{ marginRight: 8 }}
          />
          Enable AutoPay
        </label>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="autopay-day-numeric">AutoPay Day:</label>
        <input
          id="autopay-day-numeric"
          type="number"
          min={0}
          max={28}
          value={autoPayDay ?? 0}
          onChange={e => {
            const val = e.target.value ? Number(e.target.value) : null;
            setAutoPayDay(val);
          }}
          style={{ marginLeft: 8, width: 80 }}
        />
      </div>
      <p><em>
        Note: AutoPay day is the day of the month on which the AutoPay will be triggered.
        If you select zero, the AutoPay will be triggered on the second day of the billing cycle.
        Also, <u>this overrides the User level Autopay setting.</u>
      </em></p>
      <Button type="primary" onClick={handleAutoPayDaySubmit} loading={loading}>
        Save
      </Button>
    </Modal>
    </>
  );
}